import NotFoundPage from "@/pages/NotFoundPage";
import { ConfigProvider } from "antd";
import { Route, Routes } from "react-router-dom";
import "@/projects/NPS/NpsUser/styles/style.css";
import NpsUserRoutes from "./utils/routes";
import NpsUserLayout from "./layouts/NpsUserLayout";

const NpsUserApp = () => {
  return (
    <ConfigProvider
      theme={{
        hashed: false,
      }}
      componentSize="large"
    >
      <div className="nps-user-app" style={{ height: "48px" }}>
        <Routes>
          <Route element={<NpsUserLayout />}>
            {Object.values(NpsUserRoutes).map(({ path, component: Page }) => (
              <Route key={path} path={path} element={<Page />} />
            ))}
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </div>
    </ConfigProvider>
  );
};

export default NpsUserApp;
